<h2 mat-dialog-title>{{ title }}</h2>

<div mat-dialog-content>
    <form [formGroup]="groupForm" class="form row">
        <div class="col-12">
            <mat-form-field class="w-100">
                <mat-label>Name</mat-label>
                <input matInput type="text" formControlName="name" required />
            </mat-form-field>
        </div>

        <div class="col-12">
            <div class="d-flex justify-content-between align-items-center mb-1">
                <span class="fw-semibold">Options</span>
                <button mat-stroked-button type="button" (click)="addOptionRow()">Add Option</button>
            </div>

            <div formArrayName="options">
                @for (row of optionRows.controls; track row; let i = $index) {
                    <div class="row align-items-center mb-1" [formGroupName]="i">
                        <div class="col-5">
                            <mat-form-field class="w-100" subscriptSizing="dynamic">
                                <mat-label>Label</mat-label>
                                <input matInput type="text" formControlName="label" />
                            </mat-form-field>
                        </div>
                        <div class="col-5">
                            <mat-form-field class="w-100" subscriptSizing="dynamic">
                                <mat-label>Value</mat-label>
                                <input matInput type="text" formControlName="value" />
                            </mat-form-field>
                        </div>
                        <div class="col-2 d-flex align-items-center">
                            <button mat-icon-button type="button" [disabled]="i === 0" (click)="moveOptionRow(i, -1)" aria-label="Move option up">
                                <mat-icon>arrow_upward</mat-icon>
                            </button>
                            <button mat-icon-button type="button" [disabled]="i === optionRows.length - 1" (click)="moveOptionRow(i, 1)" aria-label="Move option down">
                                <mat-icon>arrow_downward</mat-icon>
                            </button>
                            <button mat-icon-button type="button" (click)="removeOptionRow(i)" aria-label="Remove option">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    </div>
                }
            </div>
        </div>
    </form>
</div>

<div mat-dialog-actions>
    <button mat-stroked-button (click)="closeDialog()">Cancel</button>
    <button mat-raised-button color="primary" (click)="submitForm()">Save</button>
</div>
